/**
 * Get a callable function error's message without the HTTP status suffix the Firebase SDK appends.
 * @param {Error|null} [error]
 * @returns {string} The message with any trailing ` [NNN]` removed, or an empty string.
 */
export function GetErrorMessageWithoutStatus(error) {
  const message = error?.message ?? '';
  // @firebase/functions 0.14.0 appends the HTTP status code which previous versions didn't.
  return message.replace(/ \[\d{3}\]$/, '');
}
